import { render, staticRenderFns } from "./RecruitCreateMessageUi.vue?vue&type=template&id=018e8f46&"
import script from "./RecruitCreateMessageUi.vue?vue&type=script&lang=js&"
export * from "./RecruitCreateMessageUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports